<div
  *ngIf="{
    auction: auction$ | async,
    isAuthenticated: isAuthenticated$ | async,
    isVolunteer: isVolunteer$ | async,
    hasUnpaidInvoice: hasUnpaidInvoice$ | async
  } as obs"
  class="gb-auction-closed-container"
>
  <div class="flex-row flex-justify-end flex-align-center">
    <button mat-button mat-dialog-close class="close-button" aria-label="Cancel">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div class="flex-col-center">
      <mat-icon class="main-icon">pan_tool</mat-icon>
      <div class="gb-auction-closed-content flex-col-center">
        <h1 mat-dialog-title translate="AUCTION_CLOSED_DIALOG.HEADING"></h1>
        <p [translate]="getDescription(obs.auction, obs.isAuthenticated, obs.isVolunteer, obs.hasUnpaidInvoice)"></p>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="flex-row flex-grow">
      <button
        *ngIf="showCheckoutButton(obs.auction, obs.isAuthenticated, obs.isVolunteer, obs.hasUnpaidInvoice)"
        (click)="navigateToCheckout(obs.auction)"
        mat-raised-button
        mat-dialog-close
        color="accent"
        class="full-width-button"
        translate="AUCTION_CLOSED_DIALOG.GO_TO_CHECKOUT"
      ></button>
      <button mat-stroked-button mat-dialog-close class="full-width-button">
        {{ getCancelButtonText(obs.auction, obs.isAuthenticated, obs.isVolunteer, obs.hasUnpaidInvoice) | translate }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
